module.exports = {
      id: "google-usage",
      viewBox: "0 0 533.5 544.3",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#google",
      toString: function () {
        return this.url;
      }
    }